import React from 'react';
import PropTypes from 'prop-types';

import BrandViewProjectItem from './BrandViewProjectItem';
import ShowMoreButton from '../ShowMoreButton';
import FilterMenu from '../FilterMenu';

const BrandViewProjectsContent = ({
  placements,
  levelTwoProjectTypesFacet,
  selectedProjectType,
  onProjectTypeChange,
  showMoreHandler,
  hasNextPage,
  isLoading,
  placementsCount,
  brandName,
  isFiltering,
}) => (
  <div className="row">
    <div className="large-3 medium-12 small-12 columns">
      <FilterMenu
        filters={levelTwoProjectTypesFacet}
        selectedFilter={selectedProjectType}
        filterChangeHandler={onProjectTypeChange}
        isLoading={isFiltering}
      />
    </div>
    <div className="columns p-r mb-xxs">
      {placements.map((placement, i) => (
        <BrandViewProjectItem
          key={placement.id}
          brandName={brandName}
          project={placement.project}
          notes={placement.notes}
          isLast={i + 1 === placements.length}
        />
      ))}
      <ShowMoreButton
        showMoreHandler={showMoreHandler}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        remainingItems={placementsCount - placements.length}
        text="View More Projects"
      />
      {isFiltering && <div className="p-a relative-center m-auto bg-white cursor-not-allowed" style={{ opacity: 0.85 }} />}
    </div>
  </div>
);

BrandViewProjectsContent.propTypes = {
  placements: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    media: PropTypes.arrayOf(PropTypes.shape({
      mediaItem: PropTypes.shape({
        url: PropTypes.string,
      }),
    })),
    firms: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
  })),
  levelTwoProjectTypesFacet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedProjectType: PropTypes.string,
  onProjectTypeChange: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool,
  showMoreHandler: PropTypes.func,
  placementsCount: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  brandName: PropTypes.string,
  isFiltering: PropTypes.bool.isRequired,
};

BrandViewProjectsContent.defaultProps = {
  placements: [{
    name: '',
    media: [{
      mediaItem: {
        url: '',
      },
    }],
    firms: [{
      name: '',
    }],
  }],
  hasNextPage: false,
  showMoreHandler: () => {},
  placementsCount: 0,
  brandName: '',
  selectedProjectType: 'All',
};

export default BrandViewProjectsContent;
